import type { LandingContent } from './landingContentTypes.js';
import { globusCampaignContent } from './landingContentGlobusCampaign.js';
import * as shared from './landingContentShared.js';
const { industryCare, industryCraft, industryRetail, heroPflege, heroHandwerk, heroHandel, heroUnternehmenBedarf, heroUnternehmenBranchen, heroUnternehmenDokumente, heroUnternehmenIntegration, partnerGlobus, partnerTempusleben, partnerEmek, teamGerdSchneider, groupPhoto, contact } = shared;
import { deContent } from './landingContent.de.js';
import { trContent } from './landingContent.tr-base.js';

export const activeTrContent: LandingContent = {
  ...trContent,
  locale: 'tr',
  languageLabel: 'Türkçe',
  nav: [
    { label: 'Bakım', href: '/branchen/pflege' },
    { label: 'Perakende', href: '/branchen/einzelhandel' },
    { label: 'Zanaat', href: '/branchen/handwerk' },
  ],
  heroFanApplicant: {
    badge: 'Yurt dışından gelen adaylar için',
    avatars: [industryCare, industryRetail, industryCraft],
    title: 'Almanya’daki mesleki başlangıcın burada başlar.',
    highlight: 'burada başlar.',
    intro: 'Almanya’da çalışmak istiyor ve güvenilir bir yol arıyorsan Viva Porta sana uygun sektörleri gösterir, sonraki adımları açıklar ve Almanya’ya varana kadar kişisel olarak yanında olur.',
    trustLabel: '',
    cards: [
      {
        eyebrow: 'Bakım',
        title: 'Bakım uzmanı olarak başla',
        image: heroPflege,
        imageAlt: 'Aydınlık modern bir bakım kurumunda bakım uzmanı',
        href: '/branchen/pflege',
      },
      {
        eyebrow: 'Perakende',
        title: 'Globus ile perakendede başla',
        image: heroHandel,
        imageAlt: 'Modern bir perakende mağazasında çalışan kişi',
        href: '/branchen/einzelhandel',
      },
      {
        eyebrow: 'Zanaat',
        title: 'Zanaatte aktif rol al',
        image: heroHandwerk,
        imageAlt: 'Aydınlık bir atölyede çalışan uzman',
        href: '/branchen/handwerk',
      },
    ],
  },
  heroFanCompany: {
    badge: 'Almanya’daki işverenler için',
    avatars: [industryCare, industryRetail, industryCraft],
    title: 'Ekibinize gerçekten uyan uluslararası çalışanlar kazanın.',
    highlight: 'gerçekten uyan',
    intro: 'Güvenilir uluslararası çalışanlar mı arıyorsunuz? Viva Porta ihtiyacınızı netleştirir, profilleri değerlendirir, formaliteleri koordine eder ve çalışanların işletmenize uyumunu destekler.',
    trustLabel: '',
    cards: [
      {
        eyebrow: 'İhtiyaç',
        title: 'Personel ihtiyacını netleştir',
        image: heroUnternehmenBedarf,
        imageAlt: 'Bir işverenle danışmanlık görüşmesi',
        href: '#kontakt',
        quote: 'Açık pozisyonlarınızı bize anlatın. İhtiyacı, zaman planını ve gerçekçi sonraki adımları birlikte değerlendirelim.',
        quoteAuthor: 'Personel ihtiyacını netleştirin',
        quoteRole: 'İhtiyacı görüşün',
      },
      {
        eyebrow: 'Sektörler',
        title: 'Gerçek rollere uygun profiller',
        image: heroUnternehmenBranchen,
        imageAlt: 'Modern bir işletmede çalışan ekip',
        href: '#branchen',
        quote: 'Sektör çözümlerimizi keşfedin ve somut görevler için uygun profilleri nasıl hazırladığımızı görün.',
        quoteAuthor: 'Uygun profilleri bulun',
        quoteRole: 'Sektörleri inceleyin',
      },
      {
        eyebrow: 'Formaliteler',
        title: 'Belgeler koordine edilir',
        image: heroUnternehmenDokumente,
        imageAlt: 'Uluslararası işe alım için belgeler ve dijital planlama',
        href: '#ablauf',
        quote: 'Seçim, belgeler, ülkeye giriş ve işe başlangıcın nasıl şeffaf biçimde koordine edildiğini inceleyin.',
        quoteAuthor: 'Süreci güvenle planlayın',
        quoteRole: 'Süreci inceleyin',
      },
      {
        eyebrow: 'Uyum',
        title: 'Ekibe uyumu destekle',
        image: heroUnternehmenIntegration,
        imageAlt: 'Uluslararası çalışan ekipte karşılanıyor',
        href: '#kontakt',
        quote: 'Hazırlık, onboarding ve kişisel desteğin ekibinizi uzun vadede nasıl güçlendireceğini birlikte konuşalım.',
        quoteAuthor: 'Ekibe uyumu birlikte güçlendirin',
        quoteRole: 'İletişime geçin',
      },
    ],
  },
  globusCampaignApplicant: globusCampaignContent.tr.applicant,
  globusCampaignCompany: globusCampaignContent.tr.company,
  intro: {
    eyebrow: 'Viva Porta hakkında',
    title: 'Almanya yolculuğun net, planlı ve kişisel destekle ilerler.',
    titleHighlight: 'destekle',
    text: 'Viva Porta’nın vize ve taşınma süreçlerindeki deneyimini uluslararası kariyer yollarına dair kapsamlı bilgiyle birleştiriyoruz. Böylece Almanya’da profesyonel bir gelecek kurmak isteyen insanlar için yapılandırılmış bir yol oluşur.',
    metrics: [
      { value: '360°', label: 'Dil, denklik, vize ve varış için destek' },
      { value: '2', label: 'İki kültür, tek ekip: Almanya ve Türkiye' },
      { value: '24/7', label: 'Kritik aşamalarda ulaşılabilir destek' },
    ],
  },
  industryOverview: {
    eyebrow: 'Sektörler',
    title: 'Sadece personel aracılığı değil: doğru insanları sizinle buluşturuyoruz.',
    titleHighlight: 'doğru insanları',
    text: 'Viva Porta şirketleri ve uluslararası adayları bireysel, kişisel ve özel bir süreçle bir araya getirir. Sadece diplomalara değil; insanlara, ekiplere, beklentilere ve iş birliğinin uzun vadede gerçekten taşıyıp taşımayacağına bakarız.',
    items: [
      {
        iconClass: 'icon-[material-symbols--medical-services]',
        title: 'Bakım',
        text: 'Nitelikli bakım uzmanlarını uzun vadeli entegre etmek isteyen klinikler, bakım kurumları ve ambulans bakım hizmetleri için.',
        href: '/branchen/pflege',
        linkLabel: 'Bakımı incele',
      },
      {
        iconClass: 'icon-[material-symbols--storefront]',
        title: 'Perakende',
        text: 'Globus, taze ürün reyonları, satış ve kalıcı personel ihtiyacı olan hizmet odaklı ekipler için.',
        href: '/branchen/einzelhandel',
        linkLabel: 'Perakendeyi incele',
      },
      {
        iconClass: 'icon-[material-symbols--construction]',
        title: 'Zanaat',
        text: 'Genç yetenek ve uzman açığını yapılandırılmış ve insani bir şekilde çözmek isteyen zanaat işletmeleri için.',
        href: '/branchen/handwerk',
        linkLabel: 'Zanaatı incele',
      },
    ],
  },
  laborShortage: {
    ...deContent.laborShortage,
    eyebrow: 'Uzman açığını anlamak',
    title: 'Boş pozisyonlar riske dönüştüğünde',
    titleHighlight: 'riske',
    text: 'Misyonumuz personel açığından kısa vadeli gelir elde etmek değil. Viva Porta toplumsal bir sorunu çözmek istiyor: şirketlerin güvenilir insanlara, uluslararası adayların adil fırsatlara ve iki tarafın da insani kalan bir desteğe ihtiyacı var.',
    stats: [
      {
        value: '3,2 milyon',
        label: 'yüksek net göçe rağmen 2030’ların ortasına kadar çalışma çağındaki nüfusta beklenen azalma.',
        sourceLabel: 'Destatis, 2025',
        sourceHref: deContent.laborShortage.stats[0]?.sourceHref ?? '',
      },
      {
        value: '400.000',
        label: 'IAB’ye göre iş gücü arzını uzun vadede yaklaşık sabit tutmak için gereken yıllık net göç.',
        sourceLabel: 'IAB',
        sourceHref: deContent.laborShortage.stats[1]?.sourceHref ?? '',
      },
      {
        value: '768.000',
        label: 'IW öngörüsüne göre arz ve talep birbirinden uzaklaşmaya devam ederse 2028’e kadar nitelikli biçimde doldurulamayabilecek pozisyon.',
        sourceLabel: 'IW / iwd',
        sourceHref: deContent.laborShortage.stats[2]?.sourceHref ?? '',
      },
    ],
    points: [
      {
        iconClass: 'icon-[material-symbols--volunteer-activism]',
        title: 'Misyonumuz nedir?',
        text: 'İnsanları yalnızca özgeçmişe veya açık pozisyona indirgemeden bakım, zanaat, ticaret ve ekipleri güçlendirmek istiyoruz. Bizim için aracılık ancak gerçek bir perspektif oluştuğunda anlamlıdır.',
      },
      {
        iconClass: 'icon-[material-symbols--diversity-1]',
        title: 'Yaklaşımımız nereden geliyor?',
        text: 'Enes, Serife ve Murat güçlü bir sosyal ve kâr amacı gütmeyen çalışma geçmişine sahip: insana yakınlık, entegrasyon anlayışı ve sorumluluk çalışmalarımızı belirler. Kirstin ve Ergün bu yaklaşımı organizasyon ve günlük süreç deneyimiyle tamamlar.',
      },
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Wilhelm neden yatırım yapıyor?',
        text: 'Wilhelm Viva Porta’yı destekliyor çünkü burada uzman aracılığı yalnızca bir iş modeli olarak düşünülmüyor. Amaç şirketlere yardımcı olan ve insanlara adil, uzun vadeli bir başlangıç sağlayan bir yapı kurmak.',
      },
    ],
    sources: [
      { label: 'Federal İş Ajansı: Darboğaz analizi', href: deContent.laborShortage.sources[0]?.href ?? '' },
      { label: 'Destatis: Demografik değişim', href: deContent.laborShortage.sources[1]?.href ?? '' },
      { label: 'IAB: İş gücü arzı ve göç', href: deContent.laborShortage.sources[2]?.href ?? '' },
      { label: 'IW: Nitelikli çalışan açığı büyüyor', href: deContent.laborShortage.sources[3]?.href ?? '' },
    ],
  },
  process: {
    eyebrow: 'İş birliği süreci',
    title: 'İhtiyaçtan gerçek uyuma kadar net bir süreç.',
    titleHighlight: 'uyuma',
    text: 'Uluslararası personel kazanımı yapı ister. Viva Porta ilk görüşmeden seçim, hazırlık, formaliteler ve günlük iş hayatına entegrasyona kadar her adımı anlaşılır hale getirir.',
    steps: [
      {
        iconClass: 'icon-[material-symbols--fact-check]',
        title: 'İhtiyacı anlamak',
        text: 'Sektör, rol, nitelik, başlangıç zamanı, dil, çalışma koşulları ve entegrasyon imkanlarını netleştiririz.',
      },
      {
        iconClass: 'icon-[material-symbols--manage-search]',
        title: 'Uygun adayları bulmak',
        text: 'Profiller mesleki, dilsel ve kişisel olarak ön değerlendirmeden geçer; böylece şirketler sağlam karar verebilir.',
      },
      {
        iconClass: 'icon-[material-symbols--school]',
        title: 'Hazırlığı desteklemek',
        text: 'Dil, rol anlayışı, beklentiler ve gerekli yeterlilik adımları erken aşamada yapılandırılır.',
      },
      {
        iconClass: 'icon-[material-symbols--approval-delegation]',
        title: 'Formaliteleri desteklemek',
        text: 'Sektöre göre belgeler, denklik, vize, çalışma izni ve gerekli kanıtları koordine ederiz.',
      },
      {
        iconClass: 'icon-[material-symbols--flight-land]',
        title: 'Varışı mümkün kılmak',
        text: 'Giriş, ilk orientasyon, konaklama ve işverenle iletişim planlı şekilde hazırlanır.',
      },
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Uzun vadeli eşlik etmek',
        text: 'Aracılıktan iki taraf için istikrarlı bir iş birliği doğması için ulaşılabilir kalırız.',
      },
    ],
  },
  values: {
    eyebrow: 'Misyon',
    title: 'Misyonumuz yapısal bir soruna insani bir yanıt vermek.',
    titleHighlight: 'insani bir yanıt',
    text: 'Viva Porta Almanya’daki uzman açığını ve uluslararası insanların motivasyonunu anlamlı şekilde bir araya getirmek ister. Kendimizi burada mesleki olarak yer edinmek isteyen insanlar ile şirketler arasında bir köprü olarak görüyoruz.',
    items: [
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Güven',
        text: 'Net iletişim, şeffaf adımlar ve sabit irtibat kişileri iki taraf için güven oluşturur.',
      },
      {
        iconClass: 'icon-[material-symbols--diversity-1]',
        title: 'İnsan merkezde',
        text: 'Her ihtiyaç ve her başvurunun arkasında beklentileri, sorumlulukları ve gelecek planları olan insanlar vardır.',
      },
      {
        iconClass: 'icon-[material-symbols--verified-user]',
        title: 'Sürdürülebilirlik',
        text: 'İyi bir aracılık sözleşmeyle bitmez. Başarısı, iş birliğinin uzun vadede taşıyıp taşımadığıyla görülür.',
      },
    ],
    bridgeTitle: 'Viva Porta neden bir köprü?',
    bridgeText:
      'Almanya güvenilir uzmanlara ihtiyaç duyuyor. Aynı zamanda uluslararası alanda burada çalışmak, öğrenmek ve yerleşmek isteyen pek çok insan var. Viva Porta bu çıkarları soyut biçimde değil; kişisel, adil ve uzun vadeli entegrasyon odağıyla birleştirir.',
    bridgeAction: { label: 'İnsanı neden merkeze koyuyoruz?', href: '/ueber-vivaporta' },
  },
  story: {
    ...deContent.story,
    eyebrow: 'İş birliğinden sesler',
    title: 'Değiştirilebilir referanslar değil, gerçek deneyimler.',
    titleHighlight: 'gerçek deneyimler',
    text: 'Editörde şirketlerden, adaylardan ve partnerlerden onaylanmış geri bildirimler resim, logo ve bağlamla düzenlenebilir.',
    quote: 'Burada gerçek bir müşteri veya aday yorumu yer alabilir. Alan, ileride güvenilir ve eksiksiz biçimde editörden yönetilecek yorumlar için hazırlanmıştır.',
    author: 'Gerçek testimonial için yer tutucu',
    role: 'Lütfen editörde onaylı bir alıntıyla değiştirin',
    testimonials: [
      {
        quote: 'Viva Porta, Türk iş gücü piyasasında mükemmel bağlantılara sahip, son derece özverili bir iş ortağıdır.',
        author: 'Gerd Schneider',
        role: 'Genel Müdür, tempusleben',
        image: teamGerdSchneider,
        imageAlt: 'tempusleben Genel Müdürü Gerd Schneider',
        logo: partnerTempusleben,
        logoAlt: 'tempusleben logosu',
      },
      {
        quote: 'İyi iş birliği, insanların hazırlandığı, anlaşıldığı ve iş hayatına kadar güvenle desteklendiği yerde başlar.',
        author: 'Viva Porta Partner Ağı',
        role: 'Hazırlık ve uyum',
        image: heroUnternehmenIntegration,
        imageAlt: 'Uluslararası bir uzman ekipte karşılanıyor',
        logo: partnerEmek,
        logoAlt: 'EMEK logosu',
      },
      {
        quote: 'Perakendede nitelik, tempo ve ekip uyumu önemlidir. Globus için uzmanları taze reyon ve hizmet rollerine özel olarak hazırlıyoruz.',
        author: 'Viva Porta × Globus',
        role: 'Perakende iş birliği',
        image: heroHandel,
        imageAlt: 'Modern bir perakende mağazasında çalışan',
        logo: partnerGlobus,
        logoAlt: 'Globus logosu',
      },
    ],
  },
  partners: {
    eyebrow: 'Partnerler & ağ',
    title: 'Gerçek ortaklıklara dayanan güven.',
    titleHighlight: 'ortaklıklara',
    text: 'Almanya ve Türkiye’de çalışmamıza güç veren seçilmiş şirketler ve ağlar.',
    trustLabel: 'GVP üyesi – Almanya Personel Hizmet Sağlayıcıları Birliği',
    items: [
      {
        name: 'Globus',
        logo: partnerGlobus,
        alt: 'Globus logosu',
        description: 'Globus gibi büyük perakendeciler için taze ürün reyonlarında uzmanlar kazanıyoruz: kasaplık, balık ve peynir. Tam da danışmanlığın müşteri trafiği, marj ve sadakat yarattığı noktada.',
        href: '/globus',
      },
      {
        name: 'tempusleben',
        logo: partnerTempusleben,
        alt: 'tempusleben logosu',
        description: 'tempusleben ambulans ve yoğun bakım odaklı bir bakım hizmetidir. İş birliği, hassas bakım alanlarında güvenilir ve insani şekilde eşlik edilen uzman kazanımının ne kadar önemli olduğunu gösterir.',
        href: 'https://tempusleben.de/',
      },
      {
        name: 'EMEK',
        logo: partnerEmek,
        alt: 'EMEK logosu',
        description: 'EMEK GmbH bir bakım hizmetidir. Bakım alanındaki bir partner olarak EMEK pratik anlayışı, iş günlüklerine yakınlığı ve insanları yalnızca yerleştirmeyen, hazırlayan bir ağı temsil eder.',
        href: 'https://emek-pflegedienst.de/',
      },
    ],
  },
  globusPartner: {
    eyebrow: 'Perakende partneri',
    title: 'Globus ile perakendede yeni bir başlangıç.',
    text: 'Globus güçlü taze ürün alanlarına sahip büyük, hizmet odaklı marketleri temsil eder. Birlikte uluslararası yeteneklerin hazırlanabildiği, eşlik edildiği ve ekiplere entegre edilebildiği bir çerçeve oluşturuyoruz.',
    image: groupPhoto,
    imageAlt: 'Viva Porta ekibi bir GLOBUS mağazasının kasap bölümünü ziyaret ediyor',
    logo: partnerGlobus,
    logoAlt: 'Globus logosu',
    primaryAction: { label: 'Perakendeyi incele', href: '/branchen/einzelhandel' },
  },
  info: {
    eyebrow: 'Ek bilgiler',
    title: 'Göç, denklik ve Almanya’daki meslekler hakkında önemli kaynaklar.',
    titleHighlight: 'kaynaklar',
    links: [
      { label: 'Almanya’da denklik', href: deContent.info.links[0]?.href ?? '' },
      { label: 'Make it in Germany', href: deContent.info.links[1]?.href ?? '' },
      { label: 'Federal İş Ajansı', href: deContent.info.links[2]?.href ?? '' },
    ],
  },
  quality: {
    eyebrow: 'Kalite ve entegrasyon',
    title: 'Ekibe sürdürülebilir şekilde ulaşan adil aracılık.',
    titleHighlight: 'sürdürülebilir',
    text: 'Başarılı aracılık bizim için havalimanında bitmez. Denetlenmiş kalite ve gerçek entegrasyon, yeni çalışanların uzun vadede kalmasına yardımcı olur.',
    stats: [
      { value: 'Uzun vadeli', label: 'İstikrarlı perspektiflere odaklanan iş birliği' },
      { value: 'Hazırlıklı', label: 'Başlangıçtan önce dilsel ve mesleki değerlendirme' },
      { value: 'Eşlik edilen', label: 'Varışın önemli aşamalarında ulaşılabilir destek' },
    ],
    points: [
      {
        iconClass: 'icon-[material-symbols--verified]',
        title: 'Adil işe alım',
        text: 'Sorumlu işe alımın kabul görmüş ilkelerine yönelir, şeffaf ve anlaşılır süreçlere önem veririz.',
      },
      {
        iconClass: 'icon-[material-symbols--diversity-3]',
        title: 'Kültürel entegrasyon',
        text: 'Kültürlerarası hazırlık ve kişisel destek, çalışanların ekipte ve günlük hayatta daha hızlı yer edinmesine yardımcı olur.',
      },
      {
        iconClass: 'icon-[material-symbols--health-and-safety]',
        title: 'Kalite kontrolü',
        text: 'Mesleki uygunluk, dil belgesi ve denklik süreçleri aracılık öncesinde izlenebilir şekilde belgelenir.',
      },
      {
        iconClass: 'icon-[material-symbols--handshake]',
        title: 'Uzun vadeli bağlılık',
        text: 'Sonraki destek ve onboarding eşliği dalgalanmayı azaltır ve işe alımın sürdürülebilir başarısını güvence altına alır.',
      },
    ],
  },
  faqCompany: {
    eyebrow: 'İşverenler için SSS',
    title: 'Uluslararası personel kazanımı hakkında yanıtlar.',
    titleHighlight: 'yanıtlar',
    text: 'Süreç, beklenti veya uygun profiller hakkında sorularınız varsa doğrudan ekibimizle konuşabilirsiniz.',
    items: [
      {
        question: 'Hangi sektörlere odaklanıyorsunuz?',
        answer: 'Viva Porta şu anda bakım, perakende ve zanaat alanlarına odaklanıyor. Her sektör için rol, nitelik ve entegrasyon ihtiyacı ayrı değerlendirilir.',
      },
      {
        question: 'Adaylar nasıl ön değerlendirmeden geçiyor?',
        answer: 'Mesleki deneyim, dil durumu, belgeler, motivasyon ve rol uyumu yapılandırılmış şekilde değerlendirilir.',
      },
      {
        question: 'Formalitelerde destek veriyor musunuz?',
        answer: 'Evet. Sektöre göre belgeler, denklik, vize, çalışma izni ve ilgili kanıtların koordinasyonunda destek sağlarız.',
      },
      {
        question: 'Süreç ne kadar sürer?',
        answer: 'Bu role, dil durumuna ve formalitelere bağlıdır. Başta gerçekçi bir zaman çizelgesi ve açık bir sonraki adım sunarız.',
      },
      {
        question: 'Başlangıçtan sonra da destek var mı?',
        answer: 'Evet. İşe başlama, iletişim ve entegrasyon aşamalarında ulaşılabilir kalırız, böylece iş birliği kalıcı hale gelebilir.',
      },
    ],
  },
  contact: {
    eyebrow: 'Bir sonraki adıma hazır mısın?',
    title: 'Almanya için ücretsiz başvur.',
    titleHighlight: 'başvur',
    text: 'Bize talebini gönder. Yolun için gerçekçi bir değerlendirme ve sonraki adımlarla sana geri döneriz.',
    primaryAction: { label: 'Ücretsiz başvur', href: contact.application },
    secondaryAction: { label: 'E-posta gönder', href: contact.mail },
    address: 'Viva Porta GmbH, Almanya',
    email: 'info@vivaporta.org',
    hours: 'Pzt - Cum: 9.00 - 17.00',
  },
  footer: {
    text: 'Viva Porta, Almanya’daki şirketleri burada mesleki olarak yer edinmek isteyen uluslararası insanlarla buluşturur. Kişisel, ciddi ve uzun vadeli.',
    links: [
      { label: 'Hemen başvur', href: '/bewerben' },
      { label: 'Globus’ta çalış', href: '/globus' },
      { label: 'Ekibimiz', href: '/team' },
      { label: 'Misyon', href: '/ueber-vivaporta' },
      { label: 'İletişim', href: '/kontakt' },
      { label: 'Ana sayfa', href: '/' },
      { label: 'Bakım', href: '/branchen/pflege' },
      { label: 'Perakende', href: '/branchen/einzelhandel' },
      { label: 'Zanaat', href: '/branchen/handwerk' },
      { label: 'Künye', href: '/impressum' },
    ],
    socialLinks: deContent.footer.socialLinks,
  },
};
